<!--整个vue文件不在使用，页面上是【现金流】，目前使用/dataManager/dayFinancialList/index.vue-->
<template>
  <a-card :bordered="false">
    <div>
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-form-item :label="'日期'">
          <el-date-picker
            v-model="paymentDate"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </a-form-item>
        <a-form-item>
          <a-button style="margin-left: 20px" type="primary" @click="getTableData()">查询</a-button>
          <a-button style="margin-left: 20px" type="primary" @click="getTableData('reset')">重置</a-button>

          <a-button style="margin-left: 20px" type="primary" @click="dayFinancialComputeFun">重新计算</a-button>
          <a-button style="margin-left: 20px" type="primary" @click="ExprotFile">导出</a-button>
          <a-upload
            ref="upload"
            name="file"
            :multiple="false"
            :action="'/api/web/webpublic/order/importCompanyDayReportExcel'"
            :headers="getHeaders()"
            :data="uploadDataParam"
            :openFileDialogOnClick="openFileDialogOnClick"
            @change="handleChangeUpload"
          >
            <a-button
              type="primary"
              @click="openFileDialogOnClick = true"
              style="margin-left: 10px"
              :loading="uploadLoading"
            >
              上传文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <el-table
        :data="tableData"
        style="width: 100%;margin-top: 20px;"
        height="600"
        border
        stripe
        v-loading="loading"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#f8f8f8', color: '#333' }"
      >
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :label="item.name"
          :prop="item.prop"
          :width="150"
          :fixed="index == 0 ? true : false"
          align="right"
        >
          <template slot="header" slot-scope="scope">
            <span>{{ item.name }}</span>
            <el-tooltip
              v-if="item.tip != undefined"
              class="item"
              effect="dark"
              :content="item.tip"
              placement="top-start"
            >
              <a-icon type="question-circle" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 20px;display: flex;justify-content: end;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConfig.pageNum"
        :page-sizes="[10, 30, 60, 100]"
        :page-size="pageConfig.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageConfig.total"
      >
      </el-pagination>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { dayFinancialList, exportCompanyDayReportExcel, dayFinancialCompute } from '@/webpublicapi/dayFinancialCompute'
import { getHeaders } from '@/utils/request'
import exportFile from '@/webpublicapi/exportFile'

import moment from 'moment'

export default {
  name: 'AppList',
  components: {},
  data() {
    return {
      pageConfig: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      paymentDate: [
        moment()
          .add(-7, 'days')
          .format('YYYY-MM-DD'),
        moment()
          .add(-1, 'days')
          .format('YYYY-MM-DD')
      ],

      uploadLoading: false,
      fileList: [],
      uploadDataParam: {
        // start: '2024-08-05',
        // end: '2024-08-11'
      },
      openFileDialogOnClick: false,

      tableData: [],

      loading: false,

      columns: [
        {
          name: '放款日期',
          prop: 'paymentDate'
        },
        {
          name: '放款总笔数',
          prop: 'paymentCountTotal'
        },
        {
          name: '新户放款笔数',
          prop: 'newPaymentCount'
        },
        {
          name: '老户放款笔数',
          prop: 'oldPaymentCount'
        },
        {
          name: '老户占比',
          prop: 'oldPaymentRate',
          tip: '老户放款笔数 / 放款总笔数'
        },
        {
          name: '新户本金',
          prop: 'newPrincipal'
        },
        {
          name: '新户件均',
          prop: 'newAverage',
          tip: '新户合同额 / 新户放款笔数'
        },
        {
          name: '新户合同金额',
          prop: 'newContractAmount'
        },
        {
          name: '复借款人数',
          prop: 'repayCount'
        },
        {
          name: '复借率',
          prop: 'repayRate',
          tip: '复借人数/ 还款总人数'
        },
        {
          name: '老户本金',
          prop: 'oldPrincipal'
        },

        {
          name: '老户件均',
          prop: 'oldAverage',
          tip: '老户合同额 / 老户放款笔数'
        },
        {
          name: '老户合同金额',
          prop: 'oldContractAmount'
        },
        {
          name: '流量成本',
          prop: 'flowFee',
          tip: '源数据_美元 * 35.24泰铢'
        },
        {
          name: '支付通道成本',
          prop: 'operatingThridFee',
          tip: '（新户本金+老户本金）*0.005 + 还款笔数 * 10泰铢'
        },
        {
          name: '新户风控成本',
          prop: 'newOfficeThridFee',
          tip: '决策数量 * 1.9755 +  授信数量  * 4.9388'
        },
        {
          name: '老户风控成本',
          prop: 'oldOfficeThridFee',
          tip: '决策数量  * 1.4816（泰铢） + 授信数量  * 2.9633（泰铢）'
        },
        {
          name: '新户回收率',
          prop: 'newRecoveryRate',
          tip: '新户还款用户数 / 新户放款用户数'
        },
        {
          name: '老户回收率',
          prop: 'oldRecoveryRate',
          tip: '老户还款用户数 / 老户放款用户数'
        },
        {
          name: '金额回收',
          prop: 'returnedAmt',
          tip: '实际还款金额'
        },
        {
          name: '牌照费用',
          prop: 'licenceFee'
        },
        {
          name: 'ocr&活体费用',
          prop: 'ocrLiveFee'
        },
        {
          name: '短信&话条费用',
          prop: 'optFee'
        },
        {
          name: '催收绩效与奖金',
          prop: 'performanceBonus'
        },
        {
          name: '泰国本地费用',
          prop: 'thaFee'
        },
        {
          name: '总部费用',
          prop: 'centerFee'
        },
        {
          name: '老挝本地费用',
          prop: 'laosFee'
        },
        {
          name: '海外房租',
          prop: 'rentFee'
        },

        {
          name: '日净现金流 ',
          prop: 'profitAmt',
          tip:
            '金额回收-新户本金-老户本金-广告成本-支付通道成本-新户风控成本-老户风控成本-牌照费用-ocr&活体费用-短信&话条费用-催收绩效与奖金-泰国本地费用-总部费用-老挝本地费用-海外房租'
        },

        {
          name: '总现金流',
          prop: 'cashFlow',
          tip: '昨天总现金流 + 当天日净现金流 '
        },
        {
          name: '在贷余额',
          prop: 'netAssets',
          tip: '未还款合同金额'
        },
        {
          name: '净资产',
          prop: 'netAssetsTotal',
          tip: '再贷余额+总现金流'
        }
      ],
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    dayFinancialComputeFun() {
      let time = {
        paymentDateStart: this.paymentDate[0],
        paymentDateEnd: this.paymentDate[1]
      }
      dayFinancialCompute(time).then(res => {
        this.getTableData()
      })
    },
    timeSelect() {
      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      // this.paymentDateStart = moment(paymentDateEnd).format('YYYY-MM-DD')
    },
    getHeaders() {
      return getHeaders()
    },
    getTableData(type = 'normal') {
      if (type == 'reset') {
        this.paymentDate[
          (moment()
            .add(-1, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .add(-7, 'days')
            .format('YYYY-MM-DD'))
        ]
      }
      this.loading = true

      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      let time = {
        paymentDateStart: this.paymentDate[0],
        paymentDateEnd: this.paymentDate[1]
      }
      Object.assign(this.pageConfig, time)

      dayFinancialList(this.pageConfig).then(res => {
        let data = res.data.rows
        this.pageConfig.total = res.data.total
        this.tableData = data

        this.loading = false
      })
    },
    ExprotFile() {
      this.loading = true

      // let paymentDateEnd = moment(this.paymentDate).valueOf()
      // paymentDateEnd -= 3600 * 1000 * 24 * 6
      let time = {
        paymentDateStart: this.paymentDate[0],
        paymentDateEnd: this.paymentDate[1]
      }

      exportCompanyDayReportExcel(time).then(res => {
        this.loading = false
        if (res.data != undefined) {
          this.$message.warning(res.data.message)
          return
        }
        this.downloadFile(res, `${time.paymentDateEnd}-Financial.xls`)
      })
    },
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.getTableData()
    },
    handleCurrentChange(page) {
      this.pageConfig.pageNum = page
      this.getTableData()
    },
    handleChangeUpload(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code === 1000) {
          this.$message.success(`${info.file.name} file uploaded successfully`)
          this.getTableData('reset')

          this.$refs.upload.sFileList = []
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        this.uploadLoading = false
        alert('system error!')
      }
    },

    downloadFile(data, name) {
      const blob = new Blob([data])
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
